import { Facebook, Instagram, Linkedin, Youtube, Globe, Phone, Mail } from "lucide-react";
import { LOGO_URL } from "../data/config";

const SOCIAL_ICONS = { Facebook, Instagram, LinkedIn: Linkedin, YouTube: Youtube };

export const Footer = ({ products, content, onScrollTo, onRegister }) => {
  const contact = content.contact;
  const footer = content.footer;
  const nav = content.navigation.filter((item) => item.id !== "home");
  return (
    <footer data-testid="site-footer" className="relative bg-surface-deep border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <img src={LOGO_URL} alt="evLUXE logo" className="brand-logo-img h-20 mb-4 w-auto" />
            <p className="text-white/55 text-sm leading-relaxed max-w-xs">
              {footer.description}
            </p>
            <div className="flex gap-3 mt-5">
              {footer.socialLinks.map((social, i) => {
                const Icon = SOCIAL_ICONS[social.platform] || Globe;
                return (
                <a
                  key={i}
                  href={social.url}
                  target={social.url === "#" ? undefined : "_blank"}
                  rel={social.url === "#" ? undefined : "noopener noreferrer"}
                  aria-label={social.platform}
                  data-testid={`footer-social-${i}`}
                  className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/60 hover:text-brand hover:border-brand/60 transition-colors"
                >
                  <Icon size={16} />
                </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">{footer.quickLinksTitle}</h4>
            <ul className="space-y-2.5">
              {nav.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => onScrollTo(n.id)}
                    className="text-white/55 hover:text-brand text-sm transition-colors"
                    data-testid={`footer-link-${n.id}`}
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">{footer.modelsTitle}</h4>
            <ul className="space-y-2.5">
              {products.slice(0, 6).map((p) => (
                <li key={p.id}>
                  <button
                    onClick={() => onRegister(p.name)}
                    className="text-white/55 hover:text-brand text-sm transition-colors text-left"
                  >
                    {p.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">{footer.contactTitle}</h4>
            <ul className="space-y-3 text-sm">
              {contact.phones.map((p) => (
                <li key={p.tel}>
                  <a href={`tel:${p.tel}`} className="flex items-center gap-2 text-white/55 hover:text-brand transition-colors">
                    <Phone size={14} /> {p.display}
                  </a>
                </li>
              ))}
              <li>
                <a href={`mailto:${contact.email}`} className="flex items-center gap-2 text-white/55 hover:text-brand transition-colors">
                  <Mail size={14} /> {contact.email}
                </a>
              </li>
              <li className="text-white/45 text-xs leading-relaxed pt-1">
                {contact.corporateOffice.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-white/40 text-xs">
            Copyright {new Date().getFullYear()} {footer.copyright}
          </p>
          <div className="flex gap-5">
            <a href={footer.privacyUrl} className="text-white/40 hover:text-brand text-xs transition-colors" data-testid="footer-privacy">
              {footer.privacyLabel}
            </a>
            <a href={footer.termsUrl} className="text-white/40 hover:text-brand text-xs transition-colors" data-testid="footer-terms">
              {footer.termsLabel}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
